import store from '@/store/index'
import { FLAG_CONSTANTS } from '@/constants'
import { Settings } from '@/Settings'
import { isInIframe, PUBLIC_LINE_SHEET_PATH_PREFIXES } from '@/utils/iframe-detect'

export const AUTH_REGISTER_V2_CHILDREN = {
  SET_EMAIL: 'set-email',
  SET_OTP: 'set-otp',
  COMPLETE_INFO: 'complete-info',
  COMPANY_INFO: 'company-info',
  CHOOSE_USER_TYPE: 'choose-user-type',
  UPLOAD_LOGO: 'upload-logo',
  UPLOAD_BANNER: 'upload-banner',
  SET_LAUNCH_DATE: 'set-launch-date',
  SET_CREDENTIALS: 'set-credentials',
  CONFIRM: 'confirm',
}

const {
  SET_EMAIL,
  SET_OTP,
  COMPLETE_INFO,
  COMPANY_INFO,
  CHOOSE_USER_TYPE,
  UPLOAD_LOGO,
  UPLOAD_BANNER,
  SET_LAUNCH_DATE,
  SET_CREDENTIALS,
  CONFIRM,
} = AUTH_REGISTER_V2_CHILDREN

// Central config for all steps
const stepConfigs = {
  [SET_EMAIL]: {
    component: 'SetEmail.vue',
    isVisible: flags => !!flags[FLAG_CONSTANTS.REGISTRATION_FLOW_V2],
  },
  [SET_OTP]: {
    component: 'SetOtp.vue',
    isVisible: flags => !!flags[FLAG_CONSTANTS.REGISTRATION_FLOW_V2],
  },
  [COMPLETE_INFO]: {
    component: 'CompleteInfo.vue',
    isVisible: () => true,
  },
  [COMPANY_INFO]: {
    component: 'CompanyInfo.vue',
    isVisible: () => true,
  },
  [CHOOSE_USER_TYPE]: {
    component: 'ChooseUserType.vue',
    isVisible: () => true,
  },
  [UPLOAD_LOGO]: {
    component: 'UploadLogo.vue',
    isVisible: flags => !!flags[FLAG_CONSTANTS.REGISTRATION_FLOW_V2],
  },
  [UPLOAD_BANNER]: {
    component: 'UploadBanner.vue',
    isVisible: flags => !!flags[FLAG_CONSTANTS.REGISTRATION_FLOW_V2],
  },
  [SET_LAUNCH_DATE]: {
    component: 'SetLaunchDate.vue',
    isVisible: () => true,
  },
  [SET_CREDENTIALS]: {
    component: 'SetCredentials.vue',
    isVisible: flags => !flags[FLAG_CONSTANTS.REGISTRATION_FLOW_V2],
  },
  [CONFIRM]: {
    component: 'Confirm.vue',
    isVisible: () => true,
  },
}

export const getAllPossibleSteps = () => {
  const flags = (store?.state?.flags) || {}
  return Object.entries(stepConfigs).map(([key, cfg]) => ({
    key,
    component: cfg.component,
    isVisible: cfg.isVisible(flags),
  }))
}

export function getActiveStepFlow() {
  return getAllPossibleSteps().filter(step => step.isVisible)
}

export function getPlgUrl() {
  return Settings.getConfig('VUE_APP_PLG_URL')
}

export function isB2bAuthRemoved() {
  return !!store.state.flags?.[FLAG_CONSTANTS.KP_2629_REMOVE_B2B_AUTH]
}

export function redirectToPlg(path = '/login') {
  window.location.replace(`${getPlgUrl()}${path}`)
}

const PLG_REDIRECT_EXCLUDED_PATHS = PUBLIC_LINE_SHEET_PATH_PREFIXES

export function isPlgRedirectExcludedPath(path = window.location.pathname) {
  return PLG_REDIRECT_EXCLUDED_PATHS.some(prefix => path.startsWith(prefix))
}

export function guardB2bAuth(to, from, next) {
  if (isB2bAuthRemoved() && !isInIframe()) {
    redirectToPlg()
    return
  }
  next()
}

export function generateAllPossibleStepRoutes() {
  const allSteps = getAllPossibleSteps()
  return allSteps.map((step, index) => ({
    path: step.key,
    name: step.key,
    component: () => import(`@/views/apps/authentication-v2/child-routes/${step.component}`),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      hideForAuth: true,
      stepNumber: index + 1,
    },
    beforeEnter: (to, from, next) => {
      const activeFlow = getActiveStepFlow()
      const found = activeFlow.find(s => s.key === to.name)
      if (!found) {
        return next({ name: 'misc-not-authorized', replace: true })
      }
      next()
    },
  }))
}
